import { traductions } from "./traductions"

export const getTraduction = (text, country) => {
  return traductions[country] ? traductions[country][text] ?? text : text
}